document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.querySelector("[data-overlay]");
  const navDrawer = document.querySelector("[data-nav-drawer]");
  const cartDrawer = document.querySelector("[data-cart-drawer]");
  const moneyFormat = document.documentElement.getAttribute("lang") === "en-GB" ? "en-GB" : undefined;

  const money = (cents) =>
    new Intl.NumberFormat(moneyFormat || undefined, {
      style: "currency",
      currency: "GBP",
    }).format((Number(cents) || 0) / 100);

  const escapeHtml = (value) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");

  const itemImage = (item) => {
    const fallback = cartDrawer?.getAttribute("data-fallback-image") || "";
    if (typeof item?.image === "string" && item.image) return item.image;
    if (item?.featured_image?.url) return item.featured_image.url;
    if (item?.image && typeof item.image === "object" && item.image.url) return item.image.url;
    return fallback;
  };

  const closeOverlays = () => {
    overlay?.classList.remove("is-on");
    navDrawer?.classList.remove("is-on");
    cartDrawer?.classList.remove("is-on");
    document.body.style.overflow = "";
  };

  const openNav = () => {
    overlay?.classList.add("is-on");
    navDrawer?.classList.add("is-on");
    cartDrawer?.classList.remove("is-on");
    document.body.style.overflow = "hidden";
  };

  const openCart = () => {
    overlay?.classList.add("is-on");
    cartDrawer?.classList.add("is-on");
    navDrawer?.classList.remove("is-on");
    document.body.style.overflow = "hidden";
  };

  const updateCount = (count) => {
    document.querySelectorAll("[data-cart-count], .cart-count").forEach((el) => {
      el.textContent = String(count || 0);
      el.classList.toggle("is-on", Number(count) > 0);
    });
  };

  const renderCart = (cart) => {
    const box = document.querySelector("[data-cart-items]");
    const total = document.querySelector("[data-cart-total]");
    if (!box) return;
    if (!cart.items?.length) {
      box.innerHTML = `<p class="empty">Your bag is empty. The jollof is waiting.</p>`;
    } else {
      box.innerHTML = cart.items
        .map((item) => {
          const variant = item.variant_title && item.variant_title !== "Default Title"
            ? `<p class="desc">${escapeHtml(item.variant_title)}</p>`
            : "";
          return `<div class="cart-row">
            <img src="${itemImage(item)}" alt="">
            <div>
              <strong>${escapeHtml(item.product_title)}</strong>
              ${variant}
              <p class="desc">${money(item.original_price)}</p>
              <div class="qty">
                <button type="button" data-cart-qty="${item.key}" data-delta="-1" aria-label="Decrease">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-qty="${item.key}" data-delta="1" aria-label="Increase">+</button>
              </div>
            </div>
            <span class="price">${money(item.final_line_price)}</span>
          </div>`;
        })
        .join("");
    }
    if (total) total.textContent = money(cart.items_subtotal_price ?? cart.total_price);
    updateCount(cart.item_count);
  };

  const fetchCart = () => fetch("/cart.js", { headers: { Accept: "application/json" } }).then((res) => res.json());

  const refreshCart = () => fetchCart().then(renderCart);

  document.querySelector("[data-open='nav']")?.addEventListener("click", openNav);
  document.querySelector("[data-open='cart']")?.addEventListener("click", (event) => {
    event.preventDefault();
    refreshCart().then(openCart);
  });
  overlay?.addEventListener("click", closeOverlays);
  document.querySelectorAll("[data-close]").forEach((btn) => btn.addEventListener("click", closeOverlays));

  document.querySelectorAll("[data-qty]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    if (!input) return;
    wrap.querySelector("[data-qty-minus]")?.addEventListener("click", () => {
      input.value = Math.max(Number(input.min || 0), Number(input.value || 1) - 1);
    });
    wrap.querySelector("[data-qty-plus]")?.addEventListener("click", () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  document.querySelectorAll("[data-size-pills]").forEach((group) => {
    const sync = () => {
      group.querySelectorAll(".size-pill").forEach((pill) => {
        pill.classList.toggle("is-on", Boolean(pill.querySelector("input:checked")));
      });
      const selected = group.querySelector("input:checked");
      if (!selected?.dataset.price) return;
      const root = group.closest(".product-card") || group.closest(".product-info");
      const price = root?.querySelector("[data-card-price]");
      if (price) price.textContent = selected.dataset.price;
    };
    group.addEventListener("change", sync);
    sync();
  });

  document.addEventListener("click", (event) => {
    const btn = event.target.closest("[data-cart-qty]");
    if (!btn || !cartDrawer?.contains(btn)) return;
    const key = btn.getAttribute("data-cart-qty");
    const delta = Number(btn.getAttribute("data-delta") || 0);
    const row = btn.closest(".cart-row");
    const current = Number(row?.querySelector(".qty span")?.textContent || 1);
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, current + delta) }),
    })
      .then((res) => res.json())
      .then(renderCart);
  });

  document.querySelectorAll("form[action*='/cart/add']").forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const button = form.querySelector("button[type='submit']");
      button?.classList.add("is-busy");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      })
        .then((res) => {
          if (!res.ok) return res.json().then((err) => Promise.reject(err));
          return fetchCart();
        })
        .then((cart) => {
          renderCart(cart);
          openCart();
        })
        .catch(() => {
          form.submit();
        })
        .finally(() => button?.classList.remove("is-busy"));
    });
  });

  const rotator = document.querySelector("[data-hero-rotator]");
  if (rotator) {
    const videos = [...rotator.querySelectorAll("video")];
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    videos.forEach((video) => {
      video.muted = true;
      video.playsInline = true;
    });
    if (!reduced && videos.length > 1) {
      let current = 0;
      videos[0].classList.add("is-on");
      videos[0].play().catch(() => {});
      setInterval(() => {
        const next = (current + 1) % videos.length;
        videos[next].currentTime = 0;
        videos[next].play().catch(() => {});
        videos[next].classList.add("is-on");
        videos[current].classList.remove("is-on");
        const prev = current;
        setTimeout(() => {
          if (!videos[prev].classList.contains("is-on")) videos[prev].pause();
        }, 900);
        current = next;
      }, 4000);
    }
  }

  document.querySelectorAll(".review-frame video").forEach((video) => {
    video.muted = true;
    video.playsInline = true;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      video.pause();
      return;
    }
    video.play().catch(() => {});
  });

  document.querySelectorAll("form").forEach((form) => {
    const trap = form.querySelector("[data-hp]");
    if (!trap) return;
    form.addEventListener("submit", (event) => {
      if (trap.value.trim()) event.preventDefault();
    });
  });
});
